// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"681":"426ca48b","786":"463970a6"}[chunkId] + ".js";
};